import {
  People,
  AddCircleOutline,
  PostAdd,
  Upgrade,
  Password,
  Business,
  Person,
  Event,
  NotificationsActiveOutlined,
  Category,
  VisibilityOff,
  Settings,
  ConfirmationNumber,
} from "@mui/icons-material";
import { TICKETING_ENABLED } from "../constants/constants";
import type { MenuRoute } from "./MenuRoute";

export const AdminRoutes = (): MenuRoute[] => [
  {
    text: "Admin",
    expandable: true,
    expanded: false,
    icon: () => <People />,
    subRoutes: [
      {
        text: "Manage Feature",
        href: "/subscription/add-feature",
        icon: () => <AddCircleOutline />,
      },
      {
        text: "Manage Plan",
        href: "/subscription/add-plan",
        icon: () => <PostAdd />,
      },
      {
        text: "View Plans",
        href: "/subscription",
        icon: () => <Upgrade />,
      },
      {
        text: "Manage Users",
        href: "/admin/users",
        icon: () => <People />,
      },
      {
        text: "Manage Events",
        href: "/admin/events",
        icon: () => <Event />,
      },
      {
        text: "Manage Categories",
        href: "/admin/categories",
        icon: () => <Category />,
      },
      {
        text: "Manage Organizations",
        href: "/admin/organizations",
        icon: () => <Business />,
      },
      ...(TICKETING_ENABLED
        ? [
            {
              text: "Settings",
              href: "/admin/settings",
              icon: () => <Settings />,
            },
          ]
        : []),
    ],
  },
  {
    text: "Profile",
    href: "/account",
    icon: () => <Person />,
  },
  {
    text: "My Events",
    href: "/account/events",
    icon: () => <Event />,
  },
  // Admins are users too — they get this menu instead of UserRoutes, so anything
  // personal in UserRoutes has to be mirrored here or admins lose it.
  ...(TICKETING_ENABLED
    ? [
        {
          text: "My Tickets",
          href: "/account/tickets",
          icon: () => <ConfirmationNumber />,
        },
      ]
    : []),
  {
    text: "Organizations",
    href: "/account/organizations",
    icon: () => <Business />,
  },
  {
    text: "My Plan",
    href: "/subscription",
    icon: () => <Upgrade />,
  },
  {
    text: "Hidden Events",
    href: "/account/events/hidden",
    icon: () => <VisibilityOff />,
  },
  {
    text: "Following",
    expandable: true,
    expanded: false,
    icon: () => <NotificationsActiveOutlined />,
    subRoutes: [
      {
        text: "Events",
        href: "/account/events/following",
        icon: () => <Event />,
      },
      {
        text: "Organizations",
        href: "/account/organizations/following",
        icon: () => <Business />,
      },
    ],
  },
  {
    text: "Password",
    href: "/account/change-password",
    icon: () => <Password />,
  },
];
